import {
  TRANSPORT_CHARGE_TYPE_OPTIONS_ENDPOINT,
  TRANSPORT_PARTICULAR_OPTIONS_ENDPOINT,
  TRANSPORTATION_COST_ADD_ENDPOINT,
  TRANSPORTATION_COST_DELETE_ENDPOINT,
  TRANSPORTATION_COST_EDIT_ENDPOINT,
  TRANSPORTATION_COST_LIST_ENDPOINT,
  TRANSPORTATION_COST_PDF_ENDPOINT,
  TRANSPORTATION_COST_REFERENCE_OPTIONS_ENDPOINT,
} from "apiServices/API_ENDPOINTS";
import { deleteData, getData, postData, putData } from "apiServices/common";

export const getTransportationCosts = async (costType, page = 1, filters = {}) => {
  const body = { cost_type: costType };
  ["invoice_number", "challan_number", "lc_number", "gate_pass_number"].forEach((key) => {
    if (filters[key]) body[key] = filters[key];
  });
  return getData(`${TRANSPORTATION_COST_LIST_ENDPOINT}?page=${page}`, false, body);
};

export const getTransportationCostById = async (id) => {
  return getData(`${TRANSPORTATION_COST_LIST_ENDPOINT}/${id}`);
};

export const getReferenceOptions = async (costType, referenceType, search = "") => {
  return getData(TRANSPORTATION_COST_REFERENCE_OPTIONS_ENDPOINT, false, {
    cost_type: costType,
    reference_type: referenceType,
    ...(search && { search }),
  });
};

export const getParticularOptions = async (type = "export") => {
  return getData(TRANSPORT_PARTICULAR_OPTIONS_ENDPOINT, false, { type });
};

export const getChargeTypeOptions = async () => {
  return getData(TRANSPORT_CHARGE_TYPE_OPTIONS_ENDPOINT);
};

export const createTransportationCost = async (payload) => {
  return postData(TRANSPORTATION_COST_ADD_ENDPOINT, payload);
};

export const updateTransportationCost = async (id, payload) => {
  return putData(`${TRANSPORTATION_COST_EDIT_ENDPOINT}/${id}`, payload);
};

export const deleteTransportationCost = async (id) => {
  return deleteData(`${TRANSPORTATION_COST_DELETE_ENDPOINT}/${id}`);
};

export const getTransportationCostPdf = async (id) => {
  return getData(`${TRANSPORTATION_COST_PDF_ENDPOINT}/${id}`, false, null, null, "arraybuffer");
};

const isPdfResponse = (response) => {
  const data = response?.data;
  if (response?.status !== 200 || !data || data.byteLength < 4) return false;
  return String.fromCharCode(...new Uint8Array(data.slice(0, 4))) === "%PDF";
};

const fetchPdfBlobUrl = async (id) => {
  const response = await getTransportationCostPdf(id);
  if (!isPdfResponse(response)) return null;
  return URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
};

export const downloadTransportationCostPdf = async (id, fileName) => {
  const blobUrl = await fetchPdfBlobUrl(id);
  if (!blobUrl) return false;

  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName || `transportation_cost_${id}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
  return true;
};

export const printTransportationCostPdf = async (id) => {
  const blobUrl = await fetchPdfBlobUrl(id);
  if (!blobUrl) return false;

  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  iframe.src = blobUrl;
  iframe.onload = () => {
    iframe.contentWindow?.focus();
    iframe.contentWindow?.print();
    // Keep the iframe alive long enough for the print dialog to read it
    setTimeout(() => {
      document.body.removeChild(iframe);
      URL.revokeObjectURL(blobUrl);
    }, 60000);
  };
  document.body.appendChild(iframe);
  return true;
};
